<template>
  <au-layout class="qrcode-decoder" title="二维码解码">
    <template slot="main">
      <div class="operate-area">
        <span class="tips">* 优先使用本地解码，如遇失败可使用远程解码重试</span>
        <au-button type="danger" @click="handleClean">清空</au-button>
      </div>
      <au-table ref="table" :data="table_data" :columns="columns" :fixed-height="120"
        @cellClick="({ row }) => { file_info = row }">
        <template slot="type" slot-scope="scope">
          <el-tag type="primary">{{ scope.props.type }}</el-tag>
        </template>
        <template slot="base64" slot-scope="scope">
          <el-image :src="scope.props.base64" :preview-src-list="[scope.props.base64]"
            style="width: 60px; height: 60px">
          </el-image>
        </template>
        <template slot="result" slot-scope="scope">
          <component :is="scope.props.result ? 'span' : 'el-tag'" type="danger">
            {{ scope.props.result || "失败" }}
          </component>
          <template v-if="!scope.props.result">
            <br />
            <au-button type="text" @click="handleDecodeQrcode(scope.props, true)">远程解码</au-button>
          </template>
        </template>
      </au-table>
    </template>
    <template slot="aside">
      <el-form ref="form" @submit.native.prevent>
        <el-form-item>
          <au-upload accept="image/png,image/jpeg" @change="onChange"></au-upload>
        </el-form-item>
        <el-form-item>
          <el-descriptions :label-style="{ width: '80px' }" :column="1" size="mini" border>
            <template slot="title">
              <span style="margin-right: 4px;">文件信息</span>
              <span style="font-size: 10px;font-weight: normal;color: #909399;">(单击行可查看详细信息)</span>
            </template>
            <el-descriptions-item label="名称">
              {{ file_info.name }}
            </el-descriptions-item>
            <el-descriptions-item label="大小">
              {{ file_info.size }}
            </el-descriptions-item>
            <el-descriptions-item label="类型">
              {{ file_info.type }}
            </el-descriptions-item>
            <el-descriptions-item label="修改时间">
              {{ file_info.lastModified }}
            </el-descriptions-item>
            <el-descriptions-item label="解码耗时">
              {{ file_info.timeConsuming }}
            </el-descriptions-item>
          </el-descriptions>
        </el-form-item>
      </el-form>
    </template>
  </au-layout>
</template>

<script>
/**
 * @description 二维码解码
 * @created 2024/04/27 15:52:11
 */
// 常量
import { FORMAT_DATETIME } from "@/constants/format"
// 工具
import { fileToBase64 } from "@/utils/file"
import { decodeQRcode as localDecodeQRcode } from "@/utils/qrcode"
// api
import { decodeQRcode as remoteDecodeQRcode } from "@/api/oioweb"
export default {
  meta: {
    title: "二维码解码"
  },
  name: "QrcodeDecoder",
  data() {
    return {
      file_info: {},
      table_data: [],
      columns: [{
        label: "名称",
        prop: "name"
      }, {
        label: "大小",
        prop: "size",
        width: "60px"
      }, {
        label: "类型",
        prop: "type",
        width: "60px"
      }, {
        label: "预览",
        prop: "base64",
        width: "80px"
      }, {
        label: "解码时间",
        prop: "decoderTime",
        width: "140px"
      }, {
        label: "解码结果",
        prop: "result",
        width: "140px",
        copy: true
      }]
    }
  },
  methods: {
    async onChange({ raw }) {
      const nameList = raw.name.split(".")
      // 导入时间
      const importTime = this.$dayjs()
      // 解码结果
      const result = await localDecodeQRcode(raw)
      // 解码时间
      const decoderTime = this.$dayjs()
      // 解码耗时
      const timeConsuming = `${this.$dayjs(decoderTime).diff(this.$dayjs(importTime))}ms`
      // 图片
      const base64 = await fileToBase64(raw)
      // 文件信息
      const fileInfo = {
        name: nameList.slice(0, nameList.length - 1).join("."),
        size: `${(raw.size / 1024 / 1024).myFixed()}M`,
        type: nameList[nameList.length - 1],
        lastModified: this.$dayjs(raw.lastModified).format(FORMAT_DATETIME),
        result,
        base64,
        importTime: importTime.format(FORMAT_DATETIME),
        decoderTime: decoderTime.format(FORMAT_DATETIME),
        timeConsuming,
        raw
      }
      this.table_data.push(fileInfo)
      this.file_info = this.table_data[0]
      this.$message.success("导入成功！")
    },
    async handleDecodeQrcode({ raw, $index }) {
      const { result, msg } = await remoteDecodeQRcode(raw)
      if (result) {
        this.$set(this.table_data[$index], "result", result)
        this.$message.success("解码成功！")
        return
      }
      this.$message.error(msg)
    },
    handleClean() {
      if (this.table_data.length === 0) {
        this.$message.warning("表格数据为空，无需清空！")
        return
      }
      this.$confirm("该操作会清空整个表格数据，且不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.file_info = {}
        this.table_data = []
        // 每次数据更新都有可能导致列重排异常，调用以下函数即可解决，列拖动导致异常同理
        this.$refs.table.doLayout()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode-decoder {

  .operate-area {
    margin-bottom: 10px;
    @include flex(space-between);

    .tips {
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
